// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xLocationAddressStyle } from "@ces/App/SharedStyles/LocationPage/LocationAddressStyles";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { locationSearchFormStyles } from "@insite/content-library/Components/LocationSearchForm";
import { RadioStyle } from "@insite/mobius/Radio";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

locationSearchFormStyles.searchContainer = {
    css: css`
        display: grid;
    `,
};
locationSearchFormStyles.searchResultRow = {
    css: css`
        overflow-y: auto;
        overflow-x: hidden;
        height: 400px;
    `,
};

locationSearchFormStyles.searchResultLocationGridItem = {
    width: 11,
    css: css`
        display: flex;
        align-items: center;
    `,
};

locationSearchFormStyles.siteMessageGridItem = {
    width: 12,
    css: css`
        ${TypographyStyle} {
            max-width: 100%;
        }
    `,
};

locationSearchFormStyles.locationNameLink = {
    typographyProps: {
        size: 16,
        weight: fontConfig.weight.bold,
        ellipsis: true,
    },
};

locationSearchFormStyles.locationAddressInfoCondensed = {
    addressText: {
        ...xLocationAddressStyle,
    },
    cityStatePostalCodeText: {
        ...xLocationAddressStyle,
    },
    countryText: {
        ...xLocationAddressStyle,
    },
};

locationSearchFormStyles.distanceUnitOfMeasureRadioGroup = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: end;
        gap: 20px;
        margin-top: 10px;

        ${RadioStyle} {
            margin: 0;

            label {
                margin: 0;
            }
        }

        & > div {
            display: inline-flex;
        }
    `,
};

locationSearchFormStyles.locationDistanceDisplayText = {
    ...xLocationAddressStyle,
};

locationSearchFormStyles.searchResultGoogleMapsDirectionLinkGridItem = {
    width: [3, 3, 2, 2, 2],
};

locationSearchFormStyles.searchResultDistanceGridItem = {
    width: [5, 5, 4, 4, 4],
};
